<template>
  <div>
    <template v-if="!sistem.app_title">
      <template v-if="!status.message">
        <p v-if="isOnline" class="ma-2">Loading...</p>
        <p v-else class="ma-2">Koneksi bermasalah!</p>
      </template>
      <p v-else class="ma-2">{{ status.message }}</p>
    </template>
    <template v-else>
      <v-app id="public" :class="sistem.app_theme">
        <v-content>
          <v-container fluid fill-height>
            <v-layout align-center justify-center>
              <keep-alive>
                <router-view></router-view>
              </keep-alive>
            </v-layout>
          </v-container>
        </v-content>
        <!-- Footer -->
        <app-footer></app-footer>
        <!-- Snackbar -->
        <app-snackbar></app-snackbar>
        <!-- overlay prgoress -->
        <v-dialog v-model="processing" persistent width="300">
          <v-card color="primary" dark>
            <v-card-text>
              <template v-if="upload_progress < 100">
                <span class="white--text"
                  >Mengunggah file...
                  <small> ({{ upload_progress }}%)</small>
                </span>
                <v-progress-linear
                  v-model="upload_progress"
                  color="white"
                  class="mb-0"
                >
                </v-progress-linear>
              </template>
              <template v-else>
                <span class="white--text">Harap sabar...</span>
                <v-progress-linear indeterminate color="white" class="mb-0">
                </v-progress-linear>
              </template>
            </v-card-text>
          </v-card>
        </v-dialog>
      </v-app>
    </template>
  </div>
</template>

<script>
import AppFooter from "@/components/app/AppFooter";
import AppSnackbar from "@/components/app/AppSnackbar";
import { mapState } from "vuex";

export default {
  name: "public",
  components: {
    AppFooter,
    AppSnackbar
  },
  computed: {
    ...mapState(["status"]),
    ...mapState("sistem", ["sistem"]),
    upload_progress: {
      get() {
        return this.$store.state.upload_progress;
      },
      set() {}
    },
    processing: {
      get() {
        return this.$store.state.processing;
      },
      set() {}
    }
  },
  mounted() {
    this.$store.dispatch("sistem/GET_SISTEM_PUBLIC");
  }
};
</script>

<style scoped>
#public {
  height: 50%;
  width: 100%;
  position: absolute;
}
</style>
